import NFTCollectionsList from '../../../data/NFTCollectionsList'
import INFTCollections from '../../../models/INFTCollections'
import { INFTCardFormatDetector } from './INFTCardFormatDetector'
import { INFTCardFormatted } from '../../../components/NFTCard/INFTCard'

export function NFTCardFormatDetector(props: INFTCardFormatDetector): JSX.Element {
  const { token, tokenContractAddress, detailUrl } = props
  const contractAddress = token ? token.tokenContract : tokenContractAddress
  const foundedCollection: INFTCollections | undefined = NFTCollectionsList.find(
    (item: INFTCollections) => item.tokenAddress.toLowerCase() === contractAddress.toLocaleLowerCase()
  )
  const NFTCardFormatted: INFTCardFormatted = {
    ...props,
    collection: foundedCollection ? foundedCollection : NFTCollectionsList[0],
    detailUrl
  }

  return foundedCollection
    ? foundedCollection.cardFormat({ ...NFTCardFormatted, collection: foundedCollection })
    : NFTCollectionsList[0].cardFormat(NFTCardFormatted)
}
